"use client";
import React from "react";
import Image from "next/image";
import useDeviceDetect from "@/hooks/useDeviceDetect";
import Link from "next/link";
import { motion } from "framer-motion";
import useLang from "@/hooks/useLang";

interface RegisterCraftmanProps {
  android?: boolean;
  iPhone?: boolean;
  isInAuth?: boolean;
}

const RegisterCraftman = ({ android, iPhone, isInAuth }: RegisterCraftmanProps) => {
  const { isAndroid, isIPhone } = useDeviceDetect();
  const { getText } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.8, ease: "easeInOut" } }}
      className="w-full flex items-center justify-center"
    >
      <div className={`${isInAuth ? "pt-0" : "pt-5"} w-11/12 flex flex-col items-center justify-center gap-4`}>
        <Link
          href={
            isAndroid || android
              ? "https://play.google.com/store/apps/details?id=com.rtf.app.ceedowpro&pli=1"
              : isIPhone || iPhone
              ? "https://apps.apple.com/fr/app/ceedow-pro/id6464310745"
              : ""
          }
          className="group p-5 rounded-2xl flex items-center justify-between gap-5 shadow-md active:shadow-lg hover:shadow-lg transition-all duration-500 w-full max-w-md bg-white hover:bg-gradient-to-r hover:from-white hover:to-amber-50 
          active:border-primary/20 active:bg-gradient-to-r active:from-white active:to-amber-50 border border-gray-200 hover:border-primary/20"
        >
          <div className="flex items-center gap-4">
            <div className="p-2 bg-white rounded-xl shadow-sm border border-gray-100 group-active:scale-105 transition-transform">
              <Image
                src={
                  "https://play-lh.googleusercontent.com/z9blO4n_VHIEHWjQq1nWkGH3EbLHDrOfvoDn26Suiln_DLKJsvdC1QMcYDLCpkUiHWY=w240-h480"
                }
                width={50}
                height={50}
                alt="logo-ceedowPro"
                className="rounded-lg"
              />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-800 group-hover:text-primary group-active:text-primary">
                {getText({ id: "register_craftman" })}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {isAndroid || android
                  ? getText({ id: "available_googleplay" })
                  : isIPhone || iPhone
                  ? getText({ id: "available_appstore" })
                  : null}
              </p>
            </div>
          </div>
          <div className="text-gray-400 group-hover:text-primary group-active:text-primary transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </div>
        </Link>
      </div>
    </motion.div>
  );
};

export default RegisterCraftman;
